<div class="introduction-text" [innerHTML]="introduction | safeHtml"></div>
<button mat-flat-button class="start-button" (click)="onStartClicked()">
  Start Evaluation
</button>
